export default __webpack_public_path__ + "static/media/CheckIcon.310fdeda.svg";